// extracted by mini-css-extract-plugin
module.exports = {"container":"Action_container__2b0v2","notAllowed":"Action_notAllowed__35UE8"};